// map.ts
import { Loader } from "@googlemaps/js-api-loader";
// import { Loader } from "@googlemaps/jest-mocks";

const mapElement = document.querySelector(".Half__innerLeftSsmap") as HTMLElement;

/**
 * Google Mapを初期化して複数のマーカーを配置する
 * @param {string} apiKey - Google Maps APIキー
 * @example
 * initMap('あなたのAPIキー');
 */
const initMap = async (apiKey: string): Promise<void> => {
    // ローダーの設定
    const loader = new Loader({
        apiKey,
        version: "weekly",
        libraries: ["marker"],
    });

    // Google Mapsの読み込み
    const { Map, InfoWindow } = await loader.importLibrary("maps");
    const { AdvancedMarkerElement } = await loader.importLibrary("marker");
    const infoWindow = new InfoWindow();

    const coordInfo = JSON.parse(document.querySelector(".Half__innerLeftSsmapjson").innerHTML)
    // console.log(coordInfo);

    const parentIcon = document.createElement('img')
    parentIcon.src = coordInfo.parent.icon

    // マーカーを配置したい場所の配列
    const locations = [
        {
            position: { lat: Number(coordInfo.parent.pos.lat), lng: Number(coordInfo.parent.pos.lng) }, // 東京駅
            title: coordInfo.parent.ttl,
            content: parentIcon,
            link: coordInfo.parent.link,
            terms: null
        },
    ];

    coordInfo.posts.forEach((post) => {
        const icon = document.createElement('img')
        icon.src = post.icon

        locations.push({
            position: { lat: Number(post.pos.lat), lng: Number(post.pos.lng) }, // 東京駅
            title: post.ttl,
            content: icon,
            link: post.link,
            terms: post.terms,
        })
    })

    // console.log(locations);

    // マップの初期化
    const map = new Map(mapElement, {
        zoom: 15,
        center: locations[0].position,
        mapId: "a197dfa2fed51392",
    });

    const postMarkers = []

    const removeClassFromPins = () => {
        postMarkers.forEach((pm) => {
            (pm.marker.element.childNodes[0] as HTMLElement).style.scale = "1"
        })
    }

    // 各位置にマーカーを配置
    locations.forEach((location) => {

        const marker = new AdvancedMarkerElement({
            map,
            position: location.position,
            title: location.title,
            content: location.content,
            gmpClickable: true,
        });
        // console.dir(marker.element);

        (marker.element.childNodes[0] as HTMLElement).style.transition = "0.35s all ease";
        (marker.element.childNodes[0] as HTMLElement).style.transformOrigin = "bottom center";

        const atag = document.createElement("a")
        atag.href = location.link
        atag.innerHTML = location.title

        marker.addListener('click', ({ domEvent, latLng }) => {
            const { target } = domEvent;
            infoWindow.close();
            infoWindow.setContent(atag);
            infoWindow.open(marker.map, marker);
            removeClassFromPins();
            (marker.element.childNodes[0] as HTMLElement).style.scale = "1.15"
        });

        if (location.terms) {
            postMarkers.push({ location, marker })
        }
    });

    infoWindow.addListener("close", () => {
        removeClassFromPins()
    })

    //マーカー切り替え
    const catBtns = document.querySelectorAll(".Half__innerLeftSsterms .Catbtn")

    // const btnOnClick = (e, customTerm?) => {
    //     catBtns.forEach((catBtn) => {
    //         catBtn.classList.remove("is-crnt")
    //     })

    //     let crntTerm = "";

    //     if (customTerm) {
    //         crntTerm = customTerm
    //         const crntTarget =
    //             catBtns.forEach((catBtn: HTMLElement) => {
    //                 if (catBtn.dataset.termSlug == crntTerm) {
    //                     catBtn.classList.add("is-crnt")
    //                 }
    //             })

    //     } else {
    //         const crntTarget = (e.currentTarget as HTMLElement)
    //         crntTerm = crntTarget.dataset.termSlug;
    //         crntTarget.classList.add("is-crnt")
    //     }

    //     postMarkers.forEach((pm) => {
    //         if (pm.location.terms[0].slug === crntTerm || crntTerm === "all") {
    //             pm.marker.map = map
    //         } else {
    //             pm.marker.map = null
    //         }
    //     })
    // }

    // catBtns.forEach((catBtn) => {
    //     catBtn.addEventListener("click", btnOnClick)
    // })

    // if (coordInfo.crnt) {
    //     btnOnClick(null, coordInfo.crnt.term)
    // }
};

// マップの初期化（APIキーを指定）
if (mapElement) {
    initMap("AIzaSyDuMBc0qHrpwtXKSxSR2rrNCQqDHr7eAt4");
}